// Calendar fields belonging to the patient's schedule, independent of the viewer.
export function scheduleWallTime(timeZone, now = new Date()) {
    if (timeZone) {
        try {
            const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {
                timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
            }).formatToParts(now).map(part => [part.type, part.value]));
            return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`;
        } catch (_) { /* Legacy responses without a usable zone keep device-local behavior. */ }
    }
    const pad = value => String(value).padStart(2, '0');
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
}
